export default "__VITE_PUBLIC_ASSET__80f779a1__"